import { EParetoActionType, EParetoDealFilter, IParetoState } from 'store/pareto/types';
import { getCachedValue, EStorageField, EModalTitle } from 'lib/storage';
import { AnyAction } from 'redux';

const buildInitialState = (): IParetoState => ({
  paretoDealIds: JSON.parse(getCachedValue(EStorageField.PARETO_DEAL_IDS, '[]')) || [],
  paretoDeals: JSON.parse(getCachedValue(EStorageField.PARETO_DEALS, '[]')) || [],
  dealFilter: EParetoDealFilter.ALL,
  regionFilter: 'all',
  productLineFilter: 'all',
  searchKeyword: '',
  isModalOpen: false,
  hasVolumeWidthBars: getCachedValue(EStorageField.PARETO_HAS_VOLUME_WIDTH_BARS) !== 'false',
  portfolioDealIds: JSON.parse(getCachedValue(EStorageField.PORTFOLIO_DEAL_IDS, '[]')) || [],
  portfolioDeals: JSON.parse(getCachedValue(EStorageField.PORTFOLIO_DEALS, '[]')) || [],
  modalTitle: EModalTitle.PARETO,
});

const ParetoReducer = (state = buildInitialState(), action: AnyAction): IParetoState => {
  switch (action.type) {
    case EParetoActionType.RESET: {
      return buildInitialState();
    }

    case EParetoActionType.SET_PARETO_DEAL_IDS: {
      return {
        ...state,
        paretoDealIds: action.payload,
      };
    }

    case EParetoActionType.SET_PORTFOLIO_DEAL_IDS: {
      return {
        ...state,
        portfolioDealIds: action.payload,
      };
    }

    case EParetoActionType.SET_PARETO_DEALS: {
      return {
        ...state,
        paretoDeals: action.payload,
      };
    }

    case EParetoActionType.SET_PORTFOLIO_DEALS: {
      return {
        ...state,
        portfolioDeals: action.payload,
      };
    }

    case EParetoActionType.SET_DEAL_FILTER: {
      return {
        ...state,
        dealFilter: action.payload,
      };
    }

    case EParetoActionType.SET_REGION_FILTER: {
      return {
        ...state,
        regionFilter: action.payload,
      };
    }

    case EParetoActionType.SET_PRODUCT_LINE_FILTER: {
      return {
        ...state,
        productLineFilter: action.payload,
      };
    }

    case EParetoActionType.SET_SEARCH_KEYWORD: {
      return {
        ...state,
        searchKeyword: action.payload,
      };
    }

    case EParetoActionType.SET_IS_MODAL_OPEN: {
      return {
        ...state,
        isModalOpen: action.payload.isModalOpen,
        modalTitle: action.payload.modalTitle,
      };
    }

    case EParetoActionType.SET_BAR_WIDTH: {
      return {
        ...state,
        hasVolumeWidthBars: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default ParetoReducer;
